/* eslint-disable @angular-eslint/component-selector */
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';
import { EmployeesMessages } from 'src/app/models/empleados';
import { EmployeesService } from 'src/app/services/employees.service';

@Component({
    selector: 'modal-obligatorios',
    templateUrl: './modal-obligatorios.component.html',
    styleUrls: ['./modal-obligatorios.component.scss'],
})
export class ModalObligatoriosComponent implements OnInit, OnDestroy {

    // #region Propiedades del componente
    @ViewChild(IonModal) modal: IonModal;
    canDismiss = false;     // Indica que la ventana modal no se puede cerrar. Para cerrarla, hay que establecer este valor a true.

    mensajesObligatorios$: Observable<EmployeesMessages[]> = this.employeesService.mensajesObligatorios$;

    // Suscripción al evento de mensajes obligatorios del servicio
    suscripcionEventoObligatorios: Subscription = this.employeesService.eventoTieneMensajesObligatorio
        .subscribe((tieneMensajesObligatorios: boolean) => {
            if (tieneMensajesObligatorios) {
                this.modal.present();
            }
        });
    suscripcionEventoSinObligatorios: Subscription = this.employeesService.eventoSinMensajesObligatorio
        .subscribe((sinMensajesObligatorios: boolean) => {
            if (sinMensajesObligatorios) {
                this.canDismiss = true;
                this.modal.dismiss(null);
            }
        });
    // #endregion

    constructor(
        public employeesService: EmployeesService,
    ) { }

    ngOnInit() { }

    ngOnDestroy(): void {
        this.suscripcionEventoObligatorios.unsubscribe();
        this.suscripcionEventoSinObligatorios.unsubscribe();
    }

    // #region Métodos públicos

    // #endregion
}
